var exports = {
  "dS": "ServerTagBadge.module__serverTagShimmer___aE9mZH",
  "xc": "ServerTagBadge.module__serverTagBadge___aE9mZH",
  "bG": "ServerTagBadge.module__interactive___aE9mZH",
  "iM": "ServerTagBadge.module__shimmer___aE9mZH",
  "vi": "ServerTagBadge.module__gradientBorder___aE9mZH",
  "In": "ServerTagBadge.module__badgeIconWrapper___aE9mZH",
  "em": "ServerTagBadge.module__tagText___aE9mZH",
  "wU": "ServerTagBadge.module__gradientText___aE9mZH",
  "gw": "ServerTagBadge.module__verifiedCheckWrapper___aE9mZH",
  "HE": "ServerTagBadge.module__verifiedCheck___aE9mZH",
};

module.exports = exports;
